import {
  Undo
} from "./chunk-XML23AVV.js";
import {
  Clipboard
} from "./chunk-DJCMRWX5.js";
import "./chunk-ZFACQRIZ.js";
import "./chunk-2524DH5P.js";
import {
  Enter,
  ShiftEnter
} from "./chunk-QHREOC7B.js";
import "./chunk-BHRKVRIW.js";
import {
  Typing
} from "./chunk-ZPQVM7W7.js";
import {
  ButtonView
} from "./chunk-R4FN2FPU.js";
import "./chunk-J3DZJUY2.js";
import {
  Command,
  Plugin,
  getCode,
  parseKeystroke
} from "./chunk-H3OD3CNY.js";
import "./chunk-624QZG55.js";

// node_modules/@ckeditor/ckeditor5-select-all/src/selectallcommand.js
var SelectAllCommand = class extends Command {
  /**
   * @inheritDoc
   */
  constructor(editor) {
    super(editor);
    this.affectsData = false;
  }
  /**
   * @inheritDoc
   */
  execute() {
    const model = this.editor.model;
    const selection = model.document.selection;
    let scopeElement = model.schema.getLimitElement(selection);
    if (selection.containsEntireContent(scopeElement) || !isSelectAllScope(model.schema, scopeElement)) {
      do {
        scopeElement = scopeElement.parent;
        if (!scopeElement) {
          return;
        }
      } while (!isSelectAllScope(model.schema, scopeElement));
    }
    model.change((writer) => {
      writer.setSelection(scopeElement, "in");
    });
  }
};
function isSelectAllScope(schema, element) {
  return schema.isLimit(element) && (schema.checkChild(element, "$text") || schema.checkChild(element, "paragraph"));
}

// node_modules/@ckeditor/ckeditor5-select-all/src/selectallediting.js
var SELECT_ALL_KEYSTROKE = parseKeystroke("Ctrl+A");
var SelectAllEditing = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "SelectAllEditing";
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    const view = editor.editing.view;
    const viewDocument = view.document;
    editor.commands.add("selectAll", new SelectAllCommand(editor));
    this.listenTo(viewDocument, "keydown", (eventInfo, domEventData) => {
      if (getCode(domEventData) === SELECT_ALL_KEYSTROKE) {
        editor.execute("selectAll");
        domEventData.preventDefault();
      }
    });
  }
};

// node_modules/@ckeditor/ckeditor5-select-all/src/selectallui.js
import selectAllIcon from "/tmp/build_5d4c22f1/node_modules/@ckeditor/ckeditor5-select-all/theme/icons/select-all.svg";
var SelectAllUI = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "SelectAllUI";
  }
  /**
   * @inheritDoc
   */
  init() {
    const editor = this.editor;
    editor.ui.componentFactory.add("selectAll", (locale) => {
      const command = editor.commands.get("selectAll");
      const view = new ButtonView(locale);
      const t = locale.t;
      view.set({
        label: t("Select all"),
        icon: selectAllIcon,
        keystroke: "Ctrl+A",
        tooltip: true
      });
      view.bind("isEnabled").to(command, "isEnabled");
      this.listenTo(view, "execute", () => {
        editor.execute("selectAll");
        editor.editing.view.focus();
      });
      return view;
    });
  }
};

// node_modules/@ckeditor/ckeditor5-select-all/src/selectall.js
var SelectAll = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get requires() {
    return [SelectAllEditing, SelectAllUI];
  }
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "SelectAll";
  }
};

// node_modules/@ckeditor/ckeditor5-essentials/src/essentials.js
var Essentials = class extends Plugin {
  /**
   * @inheritDoc
   */
  static get requires() {
    return [Clipboard, Enter, SelectAll, ShiftEnter, Typing, Undo];
  }
  /**
   * @inheritDoc
   */
  static get pluginName() {
    return "Essentials";
  }
};
export {
  Essentials as default
};
/*! Bundled license information:

@ckeditor/ckeditor5-select-all/src/selectallcommand.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-select-all/src/selectallediting.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-select-all/src/selectallui.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-select-all/src/selectall.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-select-all/src/augmentation.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-select-all/src/index.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

ckeditor5/src/select-all.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)

@ckeditor/ckeditor5-essentials/src/essentials.js:
  (**
   * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
   *)
*/
//# sourceMappingURL=@ckeditor_ckeditor5-essentials_src_essentials.js.map
